<template>
  <div :style="{ width: width +'px', height: height + 'px' }" class="videoLayer">
    <div class="head">
      <div @click="back" class="img fl"><img src="./back.png" width="35" height="28" alt=""></div>
      <div class="title fl">{{chaperNmae.key+1}}-{{chaperNmae.keys+1}} {{chaperNmae.val}}</div>
      <div class="userInfo fr">
        <div class="news fl">
          <router-link to="/notice">
            <img src="../../assets/news.png" width="26" height="26" alt="">
          </router-link>
        </div>
        <div class="portrait fl">
          <router-link to="/userInfo">
            <img :src="avatar" width="30" height="30" alt="">
          </router-link>
        </div>
      </div>
    </div>
    <div :style="{ height: ( height - 100 ) + 'px' }" class="content">
      <div :style="{ width: ( width - 480 ) + 'px' }" class="video fl">
        <videoPlayer @answerClick="answerClick" ref="video" v-if="videoFalse"></videoPlayer>
        <pdf v-if="pdfFalse" :material="info.material"></pdf>
        <questionnaire v-if="questionnaireFalse" :subjects="subjects"></questionnaire>
        <live :style="{ width: (width-480) +'px', height: (height-130) + 'px' }" ref="live" v-if="liveFalse"></live>
        <playback :style="{ width: (width-480) +'px', height: (height-130) + 'px' }" v-if="playback"></playback>
        <div class="videoRight">
          <ul class="ul">
            <li @click="videoTab(5)" v-if="liveFalse" :class=" videoIndex === 5 ? 'choice':'' ">
              <div class="img">
                <img src="./Tab-img/11.png" width="40" height="40" class="img1" alt="">
                <img src="./Tab-img/12.png" width="40" height="40" class="img2" alt="">
              </div>
              <div class="name">互动</div>
            </li>
            <li @click="videoTab(0)" :class=" videoIndex === 0 ? 'choice':'' ">
              <div class="img">
                <img src="./Tab-img/1.png" width="40" height="40" class="img1" alt="">
                <img src="./Tab-img/2.png" width="40" height="40" class="img2" alt="">
              </div>
              <div class="name">章节</div>
            </li>
            <li @click="videoTab(6)" :class=" videoIndex === 6 ? 'choice':'' ">
              <div class="img">
                <img src="./Tab-img/13.png" width="40" height="40" class="img1" alt="">
                <img src="./Tab-img/14.png" width="40" height="40" class="img2" alt="">
              </div>
              <div class="name">课案</div>
            </li>
            <li @click="videoTab(1)" v-if="videoIndex !== 5"
                :class=" videoIndex === 1 || videoIndex === 4 ? 'choice':'' ">
              <div class="img">
                <img src="./Tab-img/3.png" width="40" height="40" class="img1" alt="">
                <img src="./Tab-img/4.png" width="40" height="40" class="img2" alt="">
              </div>
              <div class="name">留言</div>
            </li>
            <li @click="videoTab(2)" :class=" videoIndex === 2 ? 'choice':'' ">
              <div class="img">
                <img src="./Tab-img/5.png" width="40" height="40" class="img1" alt="">
                <img src="./Tab-img/6.png" width="40" height="40" class="img2" alt="">
              </div>
              <div class="name">笔记</div>
            </li>
            <li @click="videoTab(3)" v-if="videoIndex !== 5" :class=" videoIndex === 3 ? 'choice':'' ">
              <div class="img">
                <img src="./Tab-img/7.png" width="40" height="40" class="img1" alt="">
                <img src="./Tab-img/8.png" width="40" height="40" class="img2" alt="">
              </div>
              <div class="name">评论</div>
            </li>
            <!--            <li @click="complete">-->
            <!--              <div class="img">-->
            <!--                <img src="./Tab-img/9.png" width="40" height="40" class="img1" alt="">-->
            <!--                <img src="./Tab-img/10.png" width="40" height="40" class="img2" alt="">-->
            <!--              </div>-->
            <!--              <div class="name">学过了</div>-->
            <!--            </li>-->
          </ul>
        </div>
      </div>
      <div class="container fr">
        <chapter ref="chapterRef" @chaperTit="chaperTit" v-if="videoIndex === 0" :height="(height - 100)"></chapter>
        <question ref="question" @changIndex="changIndex" v-if="videoIndex === 1" :height="(height - 100)"></question>
        <answer ref="answer" @changIndex="changIndex" v-if="videoIndex === 4" :height="(height - 100)"></answer>
        <notes v-if="videoIndex === 2" :height="(height - 100)"></notes>
        <comments v-if="videoIndex === 3" :height="(height - 100)"></comments>
        <interactive :chatRoom="chatRoom" v-if="videoIndex === 5" :height="(height - 100)"></interactive>
        <Inclass :url="info.url" v-if="videoIndex === 6" :height="(height - 100)"></Inclass>
      </div>
    </div>
    <div v-if="subjectFalse" class="subjectLayer">
      <subject :subjects="subjects"></subject>
    </div>
  </div>
</template>

<script>
  import videoPlayer from '@/components/videoLayer/video/video'
  import chapter from '@/components/videoLayer/chapter/chapter'
  import question from '@/components/videoLayer/question/question'
  import answer from '@/components/videoLayer/answer/answer'
  import notes from '@/components/videoLayer/notes/notes'
  import comments from '@/components/videoLayer/comments/comments'
  import subject from '@/components/videoLayer/subject/subject' // 视频答题
  import pdf from '@/components/videoLayer/pdf/pdf'
  import questionnaire from '@/components/videoLayer/questionnaire/questionnaire' // 章节代替
  import live from '@/components/videoLayer/live/live'
  import interactive from '@/components/videoLayer/interactive/interactive'
  import Inclass from '@/components/videoLayer/Inclass/Inclass' // 课案
  import playback from '@/components/videoLayer/playback/playback' // 课案

  export default {
    components: {
      videoPlayer,
      chapter,
      question,
      answer,
      notes,
      comments,
      subject,
      pdf,
      questionnaire,
      live,
      interactive,
      Inclass,
      playback
    },
    data () {
      return {
        width: 0,
        height: 0,
        videoIndex: 0,
        subjectFalse: false, // 答题界面
        id: '',
        px_course_id: '',
        px_chapters_id: '',
        course_id: '',
        info: {},
        videoFalse: false, // 视频组件显示隐藏
        subjects: [],
        chaperNmae: [],
        chaperArr: [],
        htmlTime: 0,
        videoSub: false, // 视频是否答题过
        pdfFalse: false, // 图片显示
        questionnaireFalse: false, // 答题显示
        liveFalse: false, // 直播显示
        chatRoom: {},
        playback: false // 回放
      }
    },
    mounted () {
      this.width = document.documentElement.clientWidth
      this.height = document.documentElement.clientHeight
      window.onbeforeunload = function () {
        this.$router.push({
          path: '/videoLayer',
          query: {
            course_id: this.course_id,
            id: this.id,
            px_course_id: this.px_course_id,
            px_chapters_id: this.px_chapters_id
          }
        })
      }
    },
    created () {
      this.$store.dispatch('hide')
      this.course_id = this.$route.query.course_id
      this.id = this.$route.query.id
      this.px_course_id = this.$route.query.px_course_id
      this.px_chapters_id = this.$route.query.px_chapters_id
      this.getdata()
      this.avatar = JSON.parse(localStorage.getItem('login')).avatar
    },
    methods: {
      videoTab (index) {
        this.videoIndex = index
      },
      changIndex (index) {
        this.videoIndex = index
      },
      back () { // 返回
        this.$router.go(-1)
      },
      complete () { // 学过了
        let com = {}
        for (let i = 0; i < this.chaperArr.length; i++) {
          if (Number(this.id) === this.chaperArr[i].id) {
            let x = i + 1
            if (x >= this.chaperArr.length) {
              this.$message({
                duration: 2000,
                type: 'success',
                message: '本章节学习完成'
              })
              return false
            } else {
              com = this.chaperArr[x]
            }
          }
        }
        this.id = com.id
        this.getdata()
        this.$refs.chapterRef.chaperList()
      },
      chaperTit (chaperArr) { // 获取章节
        this.chaperNmae = []
        this.chaperArr = chaperArr
        for (let i = 0; i < chaperArr.length; i++) {
          if (Number(this.id) === chaperArr[i].id) {
            this.chaperNmae.push(chaperArr[i])
          }
        }
        this.chaperNmae = this.chaperNmae[0]
      },
      answerClick (data) { // 视频答题
        this.subjects = data
        this.subjectFalse = true
      },
      getdata () {
        this.videoFalse = false
        this.liveFalse = false
        this.questionnaireFalse = false
        this.pdfFalse = false
        this.$http.post('/apipx/Lesson/lessoninfo', {
          lesson_id: this.id,
          token: JSON.parse(localStorage.getItem('login')).token
        }).then(res => {
          this.info = res.data
          if (res.data.relate_type === 'video') {
            this.videoFalse = true
            this.pdfFalse = false
            this.subjectFalse = false
            this.questionnaireFalse = false
            this.liveFalse = false
            this.playback = false
            this.$nextTick(function () { // 重新加载
              this.$refs.videoEndplayer = false
              this.$refs.video.getdata()
            })
          }
          if (res.data.relate_type === 'pdf') {
            this.videoFalse = false
            this.pdfFalse = true
            this.subjectFalse = false
            this.questionnaireFalse = false
            this.liveFalse = false
            this.playback = false
          }
          if (res.data.relate_type === 'test') {
            this.subjects = res.data.test
            this.videoFalse = false
            this.pdfFalse = false
            this.subjectFalse = false
            this.questionnaireFalse = true
            this.liveFalse = false
            this.playback = false
          }

          if (res.data.relate_type === 'live') {
            this.videoFalse = false
            this.pdfFalse = false
            this.subjectFalse = false
            this.questionnaireFalse = false
            this.liveFalse = true
            this.playback = false
            this.videoIndex = 5
            if (res.data.live.live_state === 2) {
              this.liveFalse = false
              this.playback = true
              this.videoIndex = 6
            }
          }
        })
      }
    }
  }
</script>

<style type="text/scss" lang="scss">
  .videoLayer {
    width: 100%;
    height: 100%;

    .head {
      height: 99px;
      padding: 0 60px;
      background-color: #fff;
      border-bottom: 1px solid #dcdcdc;
      overflow: hidden;

      .img {
        width: 35px;
        height: 28px;
        margin: 36px 20px 0 0;
        cursor: pointer;
      }

      .title {
        font-size: 20px;
        color: #7a7a7a;
        line-height: 100px;
      }

      .userInfo {
        height: 40px;
        width: 160px;
        margin: 30px 0 0 0;

        .news {
          width: 79px;
          height: 26px;
          border-right: 1px solid #adadad;
          margin-top: 7px;
          cursor: pointer;

          img {
            display: block;
            margin: 2px auto 0;
          }
        }

        .portrait {
          width: 80px;
          height: 40px;
          cursor: pointer;

          img {
            display: block;
            margin: 5px auto 0;
            border-radius: 50%;
          }
        }
      }
    }

    .content {
      width: 100%;

      .video {
        height: 100%;
        background-color: #000;
        position: relative;
        overflow: hidden;
        padding-right: 80px;

        .videoRight {
          width: 80px;
          height: 100%;
          background-color: #1c1f21;
          position: absolute;
          right: 0;
          top: 0;
        }

        .ul {
          height: 450px;
          width: 80px;
          position: relative;
          left: 0;
          top: 50%;
          margin: -225px 0 0 0;

          li {
            height: 90px;
            text-align: center;
            color: #fff;
            overflow: hidden;
            cursor: pointer;
            position: relative;

            .name {
              margin-top: 55px;
            }

            .img {
              position: absolute;
              left: 20px;
              top: 10px;
            }

            .img2 {
              display: none;
            }

            &.choice {
              background-color: #26292c;

              .img1 {
                display: none;
              }

              .img2 {
                display: block;
              }
            }

            &:hover {
              background-color: #26292c;

              .img1 {
                display: none;
              }

              .img2 {
                display: block;
              }
            }
          }
        }
      }

      .container {
        width: 400px;
        height: 100%;
        background-color: #fff;
      }
    }

    .subjectLayer {
      width: 100%;
      height: 100%;
      position: fixed;
      left: 0;
      top: 0;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 99;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/videoLayer/videoLayer.vue